import { Reveal, Kicker } from "./Reveal";
import { CHAPTERS, IMAGES, QUOTE } from "../data/content";

export const History = () => (
  <section id="ueber-uns" className="relative overflow-hidden py-24 md:py-32 bg-surface border-y border-line" data-testid="history-section">
    <img
      src="/images/wappen.png"
      alt=""
      aria-hidden="true"
      className="absolute -right-24 top-1/2 -translate-y-1/2 h-[820px] w-auto opacity-[0.05] pointer-events-none select-none hidden lg:block"
    />
    <div className="container-x grid lg:grid-cols-12 gap-14 lg:gap-20 relative">
      <div className="lg:col-span-5">
        <Reveal className="lg:sticky lg:top-28">
          <Kicker>Seit 1925</Kicker>
          <h2 data-testid="history-title" className="font-display text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.08] mt-4 text-ink">
            Ein Betrieb mit Geschichte. <span className="font-fraktur text-golddark">Ein Standard, der bleibt.</span>
          </h2>
          <div className="flex items-center gap-5 mt-8" data-testid="history-crest">
            <img
              src="/images/wappen.png"
              alt="Zunftwappen des Maler- und Lackiererhandwerks"
              className="h-36 w-auto"
            />
            <p className="text-sm text-muted leading-relaxed max-w-[260px]">
              Das Zunftwappen des Maler- und Lackiererhandwerks — bei Berglar geführt seit 1925.
            </p>
          </div>
          <div className="relative mt-10 border border-line rounded-xl overflow-hidden bg-white">
            <img
              src={IMAGES.history}
              alt="Das Team von Manfred Berglar, Malermeister in Olpe-Griesemert – Inhaber, Geselle und Auszubildende"
              loading="lazy"
              className="w-full aspect-[16/9] object-cover"
            />
          </div>
          <blockquote className="mt-8 border-l-2 border-gold pl-5 font-display font-medium text-xl leading-snug text-ink/90">
            {QUOTE}
          </blockquote>
        </Reveal>
      </div>
      <div className="lg:col-span-7 flex flex-col justify-center">
        <div className="border-l border-line ml-2">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.year} delay={i * 0.1}>
              <div className="relative pl-10 md:pl-14 pb-14 last:pb-0" data-testid={`history-chapter-${i}`}>
                <span className="absolute -left-[7px] top-3 w-3.5 h-3.5 rotate-45 bg-gold" aria-hidden="true" />
                <p className="font-mono font-bold text-5xl md:text-6xl tracking-tight text-golddark leading-none">{c.year}</p>
                <h3 className="font-mono text-[11px] uppercase tracking-[0.22em] font-bold text-muted mt-3">{c.title}</h3>
                <p className="text-muted leading-relaxed mt-4 max-w-xl">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <div className="mt-14 border border-line rounded-xl bg-white overflow-hidden" data-testid="history-traditionswappen">
            <div className="px-8 md:px-12 pt-10 pb-6 flex justify-center bg-surface/60">
              <img
                src="/images/traditionswappen.webp"
                alt="Traditionswappen der Familie Berglar – Firmengründer Franz Berglar Sen. (Handwerksrolle 1925), Franz Berglar Jun. (Übernahme 1967) und Manfred Berglar (Übergabe 1983)"
                loading="lazy"
                className="w-full max-w-[420px] h-auto drop-shadow-[0_18px_30px_rgba(30,39,28,0.18)]"
              />
            </div>
            <div className="border-t border-line px-8 md:px-12 py-6">
              <p className="font-mono text-[10px] uppercase tracking-[0.24em] font-bold text-golddark">Das Traditionswappen</p>
              <p className="text-sm text-muted leading-relaxed mt-2 max-w-xl">
                Drei Generationen Malermeister: Firmengründer Franz Berglar Sen. (Handwerksrolle 1925),
                Franz Berglar Jun. (Geschäftsübernahme 1967) und Manfred Berglar (Übergabe 1983).
              </p>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="pt-10 mt-4 flex items-baseline gap-6">
            <p className="font-mono font-bold text-6xl md:text-7xl text-golddark">100+</p>
            <p className="text-muted text-[11px] font-mono uppercase tracking-[0.18em] font-semibold max-w-[220px]">
              Jahre Handwerk in der Region Olpe
            </p>
          </div>
        </Reveal>
      </div>
      <div className="grid lg:grid-cols-12 gap-14 lg:gap-20 mt-16 md:mt-24 items-center border-t border-line pt-14 lg:col-span-12">
        <Reveal className="lg:col-span-7">
          <div className="relative overflow-hidden border border-line rounded-xl bg-white">
            <img
              src={IMAGES.region}
              alt="Blick über das Südsauerland bei Olpe – Heimatregion von Manfred Berglar, Malermeister"
              loading="lazy"
              className="w-full aspect-[16/9] object-cover"
            />
          </div>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <Kicker>Die Region</Kicker>
          <h3 className="font-display text-3xl md:text-4xl font-semibold tracking-tight mt-3 text-ink" data-testid="region-title">
            Zuhause in Olpe. <span className="text-golddark">Verwurzelt im Südsauerland.</span>
          </h3>
          <p className="text-muted leading-relaxed mt-5">
            Zwischen Biggesee und sanften Höhenzügen: Wir arbeiten dort, wo wir leben – in der Stadt Olpe,
            in Griesemert, in Wenden und den Dörfern des Südsauerlands. Wir kennen die Bausubstanz der Region,
            vom Fachwerkhaus bis zum modernen Neubau – und die Wege zu Bauhöfen und Verwaltungen sind kurz.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
